import { getParagraph, getExplain, getParagraphChild } from '../createRender';

let reverseParseTextView = data => {
    let obj = createRender(data);

    return obj;
}

function createRender(data) {
    if (!data.stem) {
        return {}
    }

    // 题干
    let stem = getParagraph(data.stem);
    // 答案 Array
    let answer = data.answer ? getAnswerArr(data.answer) : null;
    // 答案 Map
    let answerMap = data.answer ? getAnswerMap(data.answer) : null;
    // 选项
    let item_list = data.item_list ? data.item_list : null;
    data.item_list.map(item => {
        item.item = getParagraphChild([], item.item);
        return item;
    });
    // 解析
    let explain = data.explain ? getExplain(data.explain) : null;
    // 错误答案
    let wrong = data.wrongAnswer ? getWrongAnswer(data.wrongAnswer) : null;

    const render = { stem, answer, answerMap, item_list, explain, wrong };
    return render;
}

/**
 * 获取答案
 * @param {String} answer
 * @returns {Array}
 */
const getAnswerArr = (answer) => {
    try {
        answer = JSON.parse(answer);
    } catch (error) {
        answer = [];
    }
    return answer;
};

/**
 * 获取答案
 * @param {String} answer
 * @returns {Object}
 */
const getAnswerMap = (answer) => {
    try {
        answer = JSON.parse(answer);
    } catch (error) {
        answer = [];
    }
    const answerMap = {};
    answer.forEach(item => {
        answerMap[item.blank_id] = item.choice;
    });
    return answerMap;
};

/**
 * 获取错误答案
 */
const getWrongAnswer = wrong => {
    wrong.forEach(item => {
        item.answer = JSON.parse(item.answer);
    });
    return wrong;
};

export { reverseParseTextView };


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/select/createRender.js